import React from 'react'
import Pt from 'prop-types'
import { Link } from 'react-router'

import UpdatingAgo from 'internal-components/src/components/Time/UpdatingAgo'
import StateLabel from 'internal-components/src/components/Signup/StateLabel'
import { SignupWithExternalsRecord } from 'internal-components/src/records'

export default function Signup({ pushPath, signupWithExternals }) {
  const signup = signupWithExternals.signup
  const signupLink = `/signup/${signup.get('reference')}`

  /* eslint-disable jsx-a11y/no-static-element-interactions */
  return (
    <tr onClick={() => pushPath(signupLink)}>
      <td>
        <Link to={signupLink}>
          {signupWithExternals.offer && signupWithExternals.offer.name}
        </Link>
        <br />
        {signupWithExternals.product && (
          <small>{signupWithExternals.product.name}</small>
        )}
      </td>
      <td>
        {signup.address || <em>No address supplied</em>}
        {signup.customerReference && (
          <small className="text-muted">
            <br />
            {signup.customerReference}
          </small>
        )}
      </td>
      <td>
        <StateLabel state={signup.state} invert />
        {signup.lastTransition && (
          <small className="text-muted">
            <br />
            <UpdatingAgo moment={signup.lastTransition} />
          </small>
        )}
      </td>
      <td>
        <Link to={signupLink}>{signup.reference}</Link>
      </td>
      <td>
        <small className="text-muted">
          <UpdatingAgo moment={signup.dateAdded} />
        </small>
      </td>
    </tr>
  )
  /* eslint-enable jsx-a11y/no-static-element-interactions */
}

Signup.propTypes = {
  pushPath: Pt.func.isRequired,
  signupWithExternals: Pt.instanceOf(SignupWithExternalsRecord).isRequired,
}



// WEBPACK FOOTER //
// ./src/components/SignupList/Signup.jsx